/* import __COLOCATED_TEMPLATE__ from './input.hbs'; */
import Component from '@glimmer/component';

interface InputArgs {
  onFocusIn?: (focusEvent: void) => void;
  onFocusOut?: (blurEvent: void) => void;
}
export default class Input extends Component<InputArgs> {
  get hasFocusEvent(): boolean {
    return this.args.onFocusIn && this.args.onFocusOut ? true : false;
  }
}
